export const createClave = (data, form, prop = 'clave') => {
  const clone = [...data];
  const lastClave = parseInt(clone.pop()?.[prop], 10);
  if (!Number.isNaN(lastClave) && typeof lastClave === 'number') {
    form.setFieldsValue({ [`${prop}`]: lastClave + 1 });
  }
};

export default createClave;
